import { Controller } from "stimulus"

const mediaQuery = window.matchMedia('(max-width: 1024px)')

// Controller in charge of scrolling to a given element.
export default class extends Controller {
  static targets = [ ]

  initialize() {
    this.overlayTarget = this.data.get('overlayTarget')
    this.overlayFocus = this.data.get('overlayFocus')
    this.fn = this.onOverlayClicked.bind(this)
  }

  // If data-target="scroll-to-target-offset" is specified, we use that value.
  // If not, we'll grab the element ID from the event.curentTarget's href
  //
  scroll(event) {
    let offset = this.data.get('offset')

    if (offset == null) {
      let url = event.currentTarget.getAttribute('href') || ''
      // Support full URLs or plain hashes. Extract the hash part if present.
      let hashIndex = url.indexOf('#')
      let ref = hashIndex >= 0 ? url.slice(hashIndex) : url

      // Resolve element safely: if it's a hash (e.g. #1-nike), use getElementById
      // to avoid querySelector failures when the ID starts with a number.
      let section = this.resolveElement(ref)

      if (!section) {
        // If no target found, avoid throwing and just stop.
        event.preventDefault()
        return
      }

      let headerHeight = 0;
      let header = document.getElementsByTagName('header')[0];

      // Since we have a sticky header, the idea is to substract the header's height
      // from the section's offset
      if (header.classList.contains('sticky-header') && !mediaQuery.matches) {
        headerHeight = header.scrollHeight;
      }

      let extraOffset = parseInt(this.data.get('extraOffset')) || 0

      offset = section.getBoundingClientRect().top + window.scrollY - headerHeight + extraOffset;
    }

    window.scrollTo({
      top: offset,
      behavior: 'smooth'
    })

    // Update URL with hash if the link has a hash in its href
    let url = event.currentTarget.getAttribute('href') || ''
    let hashIndex = url.indexOf('#')
    let hash = hashIndex >= 0 ? url.slice(hashIndex) : url
    if (hash && hash.startsWith('#')) {
      window.history.pushState(null, null, hash)
    }

    let target = this.targetElement()
    let focus = this.focusElement()

    if (target != null) {
      this.toggleOverlay(target, focus);

      target.addEventListener('click', this.fn);
    }

    event.preventDefault()
  }

  onOverlayClicked() {
    let target = this.targetElement()
    let focus = this.focusElement()

    this.toggleOverlay(target, focus)

    target.removeEventListener('click', this.fn)
  }

  targetElement() {
    if (this.overlayTarget == null) {
      return null;
    }
    return this.resolveElement(this.overlayTarget)
  }

  focusElement() {
    if (this.overlayFocus == null) {
      return null;
    }
    return this.resolveElement(this.overlayFocus)
  }

  toggleOverlay(targetElement, focusElement) {
    targetElement.classList.toggle('d-none')
    if (focusElement != null) {
      focusElement.classList.toggle('z-index-1000')
      focusElement.closest('.container').classList.toggle('z-index-50')
    }
  }

  // Safely resolve a DOM element from a ref that may be a CSS selector or a hash ID.
  // - If ref starts with '#', we use getElementById to support IDs starting with numbers.
  // - Otherwise, we try querySelector; if it fails, return null.
  resolveElement(ref) {
    if (!ref) return null
    if (ref[0] === '#') {
      const id = ref.slice(1)
      return document.getElementById(id)
    }
    try {
      return document.querySelector(ref)
    } catch (e) {
      return null
    }
  }
}